import { useAuth } from 'auth'
import { GlobalShell } from 'components/GlobalShell'
import Login from 'views/Login'
import useIdentityProviders from 'hooks/useIdentityProviders'
import { useAnalytics } from 'lib/simple-analytics'

export const LoginContainer = () => {
  const { createLoginUrl, createRegisterUrl } = useAuth()
  const { providers } = useIdentityProviders()
  const { track } = useAnalytics()

  return (
    <GlobalShell>
      <Login
        identityProviders={providers}
        onLogin={provider => {
          track('PORTAL_LOGIN_CLICK', {
            identity_provider: provider.id,
          })
          window.location.href = createLoginUrl({
            idpHint: provider.id || 'email',
            redirectUri: window.location.href,
          })
        }}
        onRegister={() => {
          window.location.href = createRegisterUrl({
            redirectUri: window.location.href,
          })
        }}
      />
    </GlobalShell>
  )
}
